import { Button, Form, Input, Row, Select, Space } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCosmetologists,
  getWeeksOnlyYear,
} from '../../../../appRedux/actions';
import { getCosmetologicFeesByComestologist } from '../../../../appRedux/actions/Reports';
import { buttonLabel, formConfig, placeHolders } from '../../../../constants';
import { getFullName } from '../../../../util';
import { buildFortnightRangeOptions } from '../../../../util/fortnighltyOptions';
import { CustomSelect } from '../../../uiComponents';

export const CosmetologicFeesByCosmetologistFilter = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const { cosmetologists } = useSelector((state) => state.user);
  const { fortnightlysWeeks } = useSelector((state) => state.fortnightlys);

  const [fortnightlyRangeYearValue, setFortnightlyRangeYearValue] =
    useState('');

  useEffect(() => {
    dispatch(getCosmetologists());
  }, [dispatch]);

  const onFortnightlyRangeYearChange = async (e) => {
    const value = e.target.value;
    setFortnightlyRangeYearValue(value);

    form.setFieldsValue({ fortnightlyRange: undefined });

    if (value && value.length === 4 && /^\d{4}$/.test(value)) {
      await dispatch(getWeeksOnlyYear(value));
    }
  };

  const onSubmit = (values) => {
    dispatch(getCosmetologicFeesByComestologist(values));
  };

  return (
    <Row>
      <Form {...formConfig} onFinish={onSubmit} form={form}>
        <Space>
          <Form.Item name="fortnightlyRangeYear">
            <Input
              placeholder={placeHolders.typeYear}
              style={{ width: '150px' }}
              value={fortnightlyRangeYearValue}
              onChange={onFortnightlyRangeYearChange}
              maxLength={4}
            />
          </Form.Item>

          <Form.Item name="date">
            <Select
              placeholder={placeHolders.fortnightly}
              style={{ width: '350px' }}
              disabled={!fortnightlyRangeYearValue}
              options={buildFortnightRangeOptions(fortnightlysWeeks)}
              showSearch
              optionFilterProp="label"
            />
          </Form.Item>

          <Form.Item name="userId">
            <CustomSelect
              placeholder={placeHolders.cosmetologist}
              style={{ minWidth: '200px' }}
              options={cosmetologists?.map(
                ({ id, name, lastName, motherLastName }) => ({
                  value: id,
                  label: getFullName({ name, lastName, motherLastName }),
                })
              )}
            ></CustomSelect>
          </Form.Item>

          <Form.Item>
            <Button type="primary" className="btn-form" htmlType="submit">
              {buttonLabel.search}
            </Button>
          </Form.Item>
        </Space>
      </Form>
    </Row>
  );
};
